import Image1 from "../assets/images/products/jbl660nc-1.png";
import Image2 from "../assets/images/products/ChatGPT Image Jul 17, 2025, 05_27_47 PM.png";
import Image3 from "../assets/images/products/ChatGPT_Image_Jul_17__2025__06_00_25_PM-removebg-preview.png";
import Image4 from "../assets/images/image1.webp";
import Image5 from "../assets/images/movse-CrXJrG4q.avif";
import Image6 from "../assets/images/products/POWER_SAFF_Tubular_Battery_Statement-removebg-preview1.png";
import Image7 from "../assets/images/prodcut11-removebg-preview-CEEl3h0m.png";
import Image8 from "../assets/images/prodcut6-removebg-preview-CAMixpcs.png";
import Image9 from "../assets/images/products/POWER_SAFF_Tubular_Deep-Cycle_Battery-removebg-preview.png";
import Image10 from "../assets/images/product1-removebg-preview-B9JUCw62.png";
import Image11 from "../assets/images/product2-removebg-preview-CwORi1op.png";
import Image12 from "../assets/images/product3-removebg-preview-B2pkgGdd.png";
import Image13 from "../assets/images/products/jbl-endu-1.png";
import Image14 from "../assets/images/watch1-CzUhC8my.avif";
import Image15 from "../assets/images/products/boat410-2.png";
import Image16 from "../assets/images/products/jbl500bt-1.png";
import Image17 from "../assets/images/products/boat381-1.png";
import Image18 from "../assets/images/products/sony-ex14ap-1.png";
import Image19 from "../assets/images/products/boat228-1.png";
import Image20 from "../assets/images/product4-removebg-preview-BiEgiAnL.png";
import Image21 from "../assets/images/product5-removebg-preview-N1_TA0So.png";
import Image22 from "../assets/images/product6-removebg-preview-DAC2mlE5.png";
import Image23 from "../assets/images/st1_azyp-v8-removebg-preview.png-DArmXBga.avif";
import Image24 from "../assets/images/batterycharger-ZTbtfiB9.png";
import Image25 from "../assets/images/wired-keyboard-BAyjGj3P.webp";
import Image27 from "../assets/stereo-BbWcF3hI.webp";
import Image28 from "../assets/images/products/batt-removebg-preview.png";
import Image29 from "../assets/images/products/camera-removebg-preview.png";
import Image30 from "../assets/119A2520.png";
import Image31 from "../assets/119A2523.png";
import Image32 from "../assets/119A2529.png";
import Image34 from "../assets/119A2536.png";
import Image35 from "../assets/119A2545.png";

const productsData = [
  {
    id: 1,
    tag: "hero-product",
    tagline: "Keep the noise out, or in. You choose.",
    heroImage: Image1,
    images: [Image1],
    brand: "JBL",
    title: "JBL Live 2660NC",
    info: "Wireless Over-Ear NC Headphones",
    category: "Headphones / boAt",
    type: "Over Ear",
    finalPrice: 19990,
    originalPrice: 24990,
    connectivity: "Wireless",
    quantity: 1,
    rateCount: 5,
  },
  {
    id: 3,
    tag: "hero-product",
    tagline: "Featherweight for comfort all-day.",
    heroImage: Image2,
    images: [Image2],
    brand: "Inverter",
    title: "Inverter",
    info: " Electronics",
    category: "Battery / Inverter",
    type: "Inverter",
    finalPrice: 19990,
    originalPrice: 24990,
    rateCount: 3,
    quantity: 1,
  },
  {
    id: 7,
    tag: "hero-product",
    tagline: "Powersaff Power Battery.",
    heroImage: Image3,
    images: [Image3],
    brand: "Battery",
    title: "Battery",
    info: "Powersaff",
    category: "Battery / Inverter",
    type: "Battery",
    finalPrice: 45000,
    originalPrice: 50000,
    rateCount: 3,
    quantity: 1,
  },
  // ====================================================================================== // !

  {
    id: 2,
    tag: "featured-product",
    images: [Image4],
    brand: "Gamepad ",
    title: "GP11 Gamepad",
    info: "Gamepad",
    category: "Gamepad / Mouse",
    type: "GP11 Gamepad",
    connectivity: "Gamepad",
    finalPrice: 5000,
    originalPrice: 10990,
    rateCount: 5,
    quantity: 1,
  },

  {
    id: 4,
    tag: "featured-product",
    images: [Image5],
    brand: "Mouse",
    title: "Acer Wireless Mouse",
    info: "Mouse",
    category: "Gamepad / Mouse",
    type: "Mouse",
    connectivity: "Mouse",
    finalPrice: 800,
    originalPrice: 950,
    rateCount: 4,
    quantity: 1,
  },
  // {
  //   id: 5,
  //   images: [Image6],
  //   brand: "Battery",
  //   title: "Powersaff Tubular",
  //   info: "Powersaff Tubular",
  //   category: "Battery / Inverter",
  //   type: "On Ear",
  //   connectivity: "Battery",
  //   finalPrice: 15000,
  //   originalPrice: 20000,
  //   rateCount: 5,
  //   quantity: 1,
  // },
  {
    id: 6,
    images: [Image7],
    brand: "Inverter",
    title: "Inverter",
    info: "Inverter",
    category: "Battery / Inverter",
    type: "In Ear",
    connectivity: "Inverter",
    finalPrice: 10000,
    originalPrice: 15000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 8,
    images: [Image8],
    brand: "Inverter",
    title: " Inverter",
    info: "Inverter",
    category: "Battery / Inverter",
    type: "Inverter",
    connectivity: "Inverter",
    finalPrice: 15000,
    originalPrice: 17999,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 10,
    tag: "featured-product",
    images: [Image10],
    brand: "Electronics",
    title: "Zero Drop Solar Charge",
    info: "Zero Drop Solar Charge Controller",
    category: "Electronics",
    type: "Electronics",
    connectivity: "Electronics",
    finalPrice: 9000,
    originalPrice: 16999,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 11,
    images: [Image11],
    brand: "Inverter",
    title: "Inverter",
    info: "Inverter",
    category: "Battery / Inverter",
    type: "Inverter",
    connectivity: "Inverter",
    finalPrice: 10000,
    originalPrice: 15000,
    rateCount: 5,
    quantity: 1,
  },
  {
    id: 12,
    tag: "featured-product",
    images: [Image12],
    brand: "Electronics",
    title: "Sayok MPPT",
    info: "Sayok MPPT",
    category: "Electronics",
    type: "Electronics",
    connectivity: "Electronics",
    finalPrice: 8000,
    originalPrice: 9000,
    rateCount: 5,
    quantity: 1,
  },
  {
    id: 13,
    tag: "featured-product",
    images: [Image13],
    brand: "JBL",
    title: "JBL Endurance Run Sports",
    info: "In-Ear Wired Earphones",
    category: "Headphones / boAt",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: 999,
    originalPrice: 1599,
    rateCount: 5,
    quantity: 1,
  },
  {
    id: 14,
    tag: "featured-product",
    images: [Image14],
    brand: "Smart Watch",
    title: "Astra 3 Smart Watch",
    info: "Smart Watch",
    category: "Smart Watch",
    type: "Smart Watch",
    connectivity: "Smart Watch",
    finalPrice: 1999,
    originalPrice: 2300,
    rateCount: 5,
    quantity: 1,
  },
  {
    id: 1222,
    images: [Image15],
    brand: "Headphones",
    title: "boAt ",
    info: "In-Ear Wireless Earbuds",
    category: "Headphones / boAt",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 2299,
    originalPrice: 4990,
    rateCount: 5,
    quantity: 1,
  },
  {
    id: 16,
    images: [Image16],
    brand: "JBL",
    title: "JBL Tune 500BT",
    info: "On-Ear Wireless Headphones",
    category: "Headphones / boAt",
    type: "On Ear",
    connectivity: "Wireless",
    finalPrice: 3282,
    originalPrice: 3999,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 17,
    images: [Image17],
    brand: "Headphones",
    title: "boAt Airdopes 381",
    info: "In-Ear Wireless Earbuds",
    category: "Headphones / boAt",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 1699,
    originalPrice: 4990,
    rateCount: 5,
    quantity: 1,
  },
  {
    id: 18,
    images: [Image18],
    brand: "Headphones",
    title: "Sony MDR-EX14AP",
    info: "In-Ear Wired Earphones",
    category: "Headphones / boAt",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: 549,
    originalPrice: 1290,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 19,
    images: [Image19],
    brand: "Headphones",
    title: "Sony WI-XB400",
    info: "Wireless Extra Bass In-Ear Neckbands",
    category: "Headphones / boAt",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: 2690,
    originalPrice: 4990,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 20,
    images: [Image20],
    brand: "Electronics",
    title: "Solar Charge Controller",
    info: "Solar Charge Controller",
    category: "Electronics",
    type: "Electronics",
    connectivity: "Electronics",
    finalPrice: 7000,
    originalPrice: 10000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 21,
    images: [Image21],
    brand: "Inverter",
    title: "Sayok CPU",
    info: "Sayok CPU",
    category: "Battery / Inverter",
    type: "Inverter",
    connectivity: "Inverter",
    finalPrice: 10000,
    originalPrice: 11000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 22,
    images: [Image22],
    brand: "Inverter",
    title: "CPU Model Inverter",
    info: "CPU Model Inverter",
    category: "Battery / Inverter",
    type: "Inverter",
    connectivity: "Inverter",
    finalPrice: 15000,
    originalPrice: 17000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 23,
    tag: "featured-product",
    images: [Image23],
    brand: "Electronics",
    title: "IMPEX Kettle",
    info: "IMPEX Kettle",
    category: "Electronics",
    type: "Electronics",
    connectivity: "Electronics",
    finalPrice: 1000,
    originalPrice: 1100,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 24,
    tag: "featured-product",
    images: [Image24],
    brand: "Electronics",
    title: "Battery charger ",
    info: "Battery charger ",
    category: "Electronics",
    type: "Electronics",
    connectivity: "Electronics",
    finalPrice: 2500,
    originalPrice: 3000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 25,
    images: [Image25],
    brand: "Electronics",
    title: "Wired Keyboard",
    info: "Keyboard",
    category: "Electronics",
    type: "Electronics",
    connectivity: "Electronics",
    finalPrice: 2500,
    originalPrice: 3000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 27,
    tag: "featured-product",
    images: [Image27],
    brand: "JBL",
    title: "JBL Music Speakers",
    info: "JBL",
    category: " JBL Speakers",
    type: "JBL",
    connectivity: "JBL",
    finalPrice: 3500,
    originalPrice: 4000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 28,
    images: [Image28],
    brand: "battery",
    title: "Battery / Inverter",
    info: "Battery",
    category: "Battery / Inverter",
    type: "Battery",
    connectivity: "Battery",
    finalPrice: 23500,
    originalPrice: 24000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 29,
    images: [Image29],
    brand: "Camera",
    title: "Solar Camera",
    info: "Solar Camera",
    category: "Electronics",
    type: "Electronics",
    connectivity: "Electronics",
    finalPrice: 3500,
    originalPrice: 4000,
    rateCount: 4,
    quantity: 1,
  },

  {
    id: 30,
    images: [Image30],
    brand: "Battery",
    title: "Delta Forze",
    info: "Delta Forze",
    category: "Battery / Inverter",
    type: "Battery / Inverter",
    connectivity: "Battery",
    finalPrice: 23500,
    originalPrice: 24000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 31,
    images: [Image31],
    brand: "Battery",
    title: "AX-ON",
    info: "AX-ON",
    category: "Battery / Inverter",
    type: "Battery / Inverter",
    connectivity: "Battery",
    finalPrice: 23500,
    originalPrice: 24000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 32,
    images: [Image32],
    brand: "Battery",
    title: "AX-ON",
    info: "AX-ON",
    category: "Battery / Inverter",
    type: "Battery / Inverter",
    connectivity: "Battery",
    finalPrice: 23500,
    originalPrice: 24000,
    rateCount: 4,
    quantity: 1,
  },

  {
    id: 34,
    images: [Image34],
    brand: "Battery",
    title: "XTRA Power",
    info: "XTRA Power",
    category: "Battery / Inverter",
    type: "Battery / Inverter",
    connectivity: "Battery",
    finalPrice: 23500,
    originalPrice: 24000,
    rateCount: 4,
    quantity: 1,
  },
  {
    id: 35,
    images: [Image35],
    brand: "Battery",
    title: "XTRA Power",
    info: "XTRA Power",
    category: "Battery / Inverter",
    type: "Battery / Inverter",
    connectivity: "Battery",
    finalPrice: 23500,
    originalPrice: 24000,
    rateCount: 4,
    quantity: 1,
  },
];

export default productsData;
